/* NRN reviews: grid layout, load more, search, star filter, detail view, write-a-review form.
   No dependencies. Reviews are already in the HTML; this only arranges and filters them. */
(function () {
  'use strict';
  if (window.__nrnReviews) return;
  window.__nrnReviews = true;

  var GAP = 20;
  var REACT_KEY = 'nrn_rv_react';
  var SENT_KEY = 'nrn_rv_sent';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function icon(id, vb) { return '<svg viewBox="' + vb + '" aria-hidden="true"><use href="#' + id + '"></use></svg>'; }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || '{}');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return {}; }
  }
  function media(card) {
    return (card.dataset.m || '').split(',').filter(Boolean).map(function (s) {
      var p = s.split('|');
      return { u: p[0], w: +p[1], h: +p[2] };
    });
  }

  function init(root) {
    var list = $('[data-list]', root);
    var cards = $$('.nrn-rvc', list);
    var per = +root.dataset.per || 10;
    var state = { star: 0, q: '', shown: per, matched: cards };
    var moreWrap = $('[data-more-wrap]', root);
    var empty = $('[data-empty]', root);
    var lastW = 0;

    cards.forEach(function (c) {
      var t = $('[data-text]', c);
      c._text = t ? t.textContent : '';
      c._hay = (c._text + ' ' + $('.nrn-rvc__author', c).textContent).toLowerCase();
    });

    /* --- text clamp: 3 lines + "See more" --- */
    function clamp(card) {
      var el = $('[data-text]', card);
      if (!el || card._open) return;
      var full = card._text;
      el.textContent = full;
      var max = parseFloat(getComputedStyle(el).lineHeight) * 3 + 2;
      if (el.scrollHeight <= max) return;
      var more = document.createElement('span');
      more.className = 'nrn-rvc__more';
      more.setAttribute('role', 'button');
      more.tabIndex = 0;
      more.textContent = 'See more';
      var lo = 0, hi = full.length;
      while (lo < hi) {
        var mid = (lo + hi + 1) >> 1;
        el.textContent = full.slice(0, mid).replace(/\s+$/, '') + '... ';
        el.appendChild(more);
        if (el.scrollHeight <= max) lo = mid; else hi = mid - 1;
      }
      el.textContent = full.slice(0, lo).replace(/\s+$/, '') + '... ';
      el.appendChild(more);
    }
    function expand(card) {
      card._open = true;
      $('[data-text]', card).textContent = card._text;
      layout(true);
    }

    /* --- masonry: each card goes to the shortest column --- */
    function layout(force) {
      var w = list.clientWidth;
      if (!w) return;
      var cols = w >= 900 ? 4 : w >= 640 ? 3 : w >= 480 ? 2 : 1;
      var colW = (w - GAP * (cols - 1)) / cols;
      var vis = cards.filter(function (c) { return !c.hidden; });
      list.classList.add('is-js');
      vis.forEach(function (c) { c.style.width = colW + 'px'; });
      if (force || Math.abs(w - lastW) > 1) vis.forEach(clamp);
      lastW = w;
      var hs = [];
      for (var i = 0; i < cols; i++) hs.push(0);
      var heights = vis.map(function (c) { return c.offsetHeight; });
      vis.forEach(function (c, n) {
        var k = 0;
        for (var j = 1; j < cols; j++) if (hs[j] < hs[k] - 0.5) k = j;
        c.style.transform = 'translate(' + (k * (colW + GAP)) + 'px,' + hs[k] + 'px)';
        hs[k] += heights[n] + GAP;
      });
      list.style.height = Math.max(0, Math.max.apply(null, hs) - GAP) + 'px';
    }

    function apply() {
      state.matched = cards.filter(function (c) {
        return (!state.star || +c.dataset.s === state.star) && (!state.q || c._hay.indexOf(state.q) > -1);
      });
      cards.forEach(function (c) { c.hidden = true; });
      state.matched.slice(0, state.shown).forEach(function (c) { c.hidden = false; });
      if (moreWrap) moreWrap.hidden = state.matched.length <= state.shown;
      if (empty) empty.hidden = state.matched.length > 0;
      layout(true);
    }

    var raf = 0;
    function relayout() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { layout(false); var f = root.querySelector('[data-form]'); if (f && !f.hidden) { var bar = document.querySelector('.nrn-sticky'); root.style.setProperty('--nrn-bar', (bar ? bar.offsetHeight : 0) + 'px'); } }); }
    if ('ResizeObserver' in window) new ResizeObserver(relayout).observe(list); else window.addEventListener('resize', relayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(true); });
    layout(true);

    /* --- helpful votes: remembered on this device --- */
    var votes = store(REACT_KEY) || {};
    function paintVotes(scope, id) {
      $$('[data-react]', scope).forEach(function (b) {
        var on = votes[id] === b.dataset.react;
        var n = (+b.dataset.n || 0) + (on ? 1 : 0);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        $('b', b).textContent = n > 0 ? n : '';
      });
    }
    function vote(id, kind) {
      if (votes[id] === kind) delete votes[id]; else votes[id] = kind;
      store(REACT_KEY, votes);
      var card = cards.filter(function (c) { return c.dataset.id === id; })[0];
      if (card) paintVotes(card, id);
    }
    cards.forEach(function (c) { if (votes[c.dataset.id]) paintVotes(c, c.dataset.id); });

    /* --- events --- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var card = t.closest('.nrn-rvc');
      if (t.closest('.nrn-rvc__more') && card) { setTimeout(function () { expand(card); }, 0); return; }
      if (t.closest('[data-open]') && card) { modal.open(root, state.matched, state.matched.indexOf(card), vote, votes); return; }
      var rb = t.closest('[data-react]');
      if (rb && card) { vote(card.dataset.id, rb.dataset.react); return; }
      var fb = t.closest('[data-filter]');
      if (fb) {
        var s = +fb.dataset.filter;
        state.star = state.star === s ? 0 : s;
        $$('[data-filter]', root).forEach(function (b) {
          var on = +b.dataset.filter === state.star;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        state.shown = per;
        apply();
        return;
      }
      if (t.closest('[data-more]')) { state.shown += per; apply(); return; }
      if (t.closest('[data-write]')) { showForm(true); return; }
      if (t.closest('[data-cancel]')) { showForm(false); return; }
    });
    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('nrn-rvc__more')) {
        e.preventDefault();
        expand(e.target.closest('.nrn-rvc'));
      }
    });

    var search = $('[data-search]', root);
    var st = 0;
    if (search) search.addEventListener('input', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        state.q = search.value.trim().toLowerCase();
        state.shown = per;
        apply();
      }, 150);
    });

    /* --- write a review --- */
    var main = $('[data-main]', root);
    var formBox = $('[data-form]', root);
    /* the store has a fixed add-to-cart bar at the bottom (.nrn-sticky): keep the form buttons above it */
    function barH() { var bar = document.querySelector('.nrn-sticky'); return bar ? bar.offsetHeight : 0; }
    function showForm(on) {
      if (!formBox) return;
      formBox.hidden = !on;
      main.hidden = on;
      if (on) {
        var bh = barH();
        root.style.setProperty('--nrn-bar', bh + 'px');
        var r = formBox.getBoundingClientRect(), avail = window.innerHeight - bh, to = null;
        if (r.height + 20 <= avail) { if (r.top < 10 || r.bottom > avail - 10) to = r.top - Math.max(10, (avail - r.height) / 2); }
        else if (r.top < 10 || r.top > avail * 0.4) to = r.top - 10;
        if (to !== null) window.scrollTo({ top: window.pageYOffset + to, behavior: 'smooth' });
      }
      relayout();
    }
    if (formBox) {
      var ta = $('[data-count]', formBox);
      var out = $('[data-count-out]', formBox);
      if (ta && out) ta.addEventListener('input', function () { out.textContent = ta.value.length; });
      var form = $('form', formBox);
      if (form) form.addEventListener('submit', function () {
        try { sessionStorage.setItem(SENT_KEY, '1'); } catch (e) {}
      });

      /* --- photos: the contact form cannot carry files, so each photo is resized here, stored by the
             receiver in data-up, and only its link travels in the review e-mail --- */
      var up = $('[data-upload]', formBox);
      if (up && !(form && up.dataset.up && window.fetch && window.Promise)) up.hidden = true;
      else if (up) (function () {
        var MAX = 5, SIDE = 1600;
        var wrap = $('[data-thumbs]', up), add = $('[data-add]', up), pick = $('input[type=file]', up);
        var errBox = $('[data-upload-err]', up), field = $('[data-photos]', form), send = $('button[type=submit]', form);
        var items = [], sendText = send.textContent;
        var WARN = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0zm0 1.1a4.9 4.9 0 1 0 0 9.8 4.9 4.9 0 0 0 0-9.8zM5.45 3h1.1v4.1h-1.1zM6 7.9a.73.73 0 1 1 0 1.46.73.73 0 0 1 0-1.46z"/></svg>';

        function warn(msg) {
          errBox.hidden = !msg;
          errBox.innerHTML = msg ? WARN + '<span></span>' : '';
          if (msg) errBox.lastChild.textContent = msg;
        }
        function sync() {
          var busy = items.some(function (it) { return !it.url; });
          var urls = items.filter(function (it) { return it.url; }).map(function (it) { return it.url; });
          up.classList.toggle('has-file', items.length > 0);
          up.classList.toggle('is-full', items.length >= MAX);
          if (field) { field.value = urls.join('\n'); field.disabled = !urls.length; }
          send.disabled = busy;
          send.textContent = busy ? 'UPLOADING PHOTO...' : sendText;
          relayout();
        }
        function drop(it) {
          var i = items.indexOf(it);
          if (i < 0) return;
          items.splice(i, 1);
          it.gone = true;
          /* removed a tick later: a third-party click tracker reads the clicked element */
          setTimeout(function () { if (it.el.parentNode) it.el.parentNode.removeChild(it.el); }, 0);
          sync();
        }
        function shrink(file) {
          return new Promise(function (done, fail) {
            var src = URL.createObjectURL(file), img = new Image();
            img.onload = function () {
              var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, SIDE / Math.max(w, h, 1));
              var c = document.createElement('canvas'), data = '';
              c.width = Math.max(1, Math.round(w * k));
              c.height = Math.max(1, Math.round(h * k));
              try {
                var ctx = c.getContext('2d');
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, c.width, c.height);
                ctx.drawImage(img, 0, 0, c.width, c.height);
                data = c.toDataURL('image/jpeg', 0.85);
              } catch (e) {}
              URL.revokeObjectURL(src);
              c.width = c.height = 0;
              if (data.indexOf('data:image/jpeg;base64,') === 0) done(data.slice(23)); else fail('read');
            };
            img.onerror = function () { URL.revokeObjectURL(src); fail('read'); };
            img.src = src;
          });
        }
        function post(b64) {
          var stop = window.AbortController ? new AbortController() : null;
          var timer = setTimeout(function () { if (stop) stop.abort(); }, 60000);
          function end(v) { clearTimeout(timer); return v; }
          /* a plain string body is sent as text/plain, which needs no preflight */
          return fetch(up.dataset.up, { method: 'POST', body: JSON.stringify({ d: b64, p: up.dataset.pid || '' }), credentials: 'omit', signal: stop ? stop.signal : undefined })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              end();
              if (!j || !j.ok || !/^https:\/\/drive\.google\.com\/file\/d\/[\w-]+\/view$/.test(j.url)) throw 'send';
              return j.url;
            }, function () { end(); throw 'send'; });
        }
        function take(file) {
          var it = { url: '', gone: false, el: document.createElement('div') };
          it.el.className = 'nrn-rvu__item is-busy';
          it.el.innerHTML = '<button type="button" class="nrn-rvu__x" data-drop aria-label="Remove photo">' + icon('nrn-x', '0 0 10 10') + '</button><div class="nrn-rvu__thumb"><img alt="Your photo"></div>';
          it.el._it = it;
          wrap.insertBefore(it.el, add);
          items.push(it);
          sync();
          shrink(file).then(function (b64) {
            if (it.gone) return;
            $('img', it.el).src = 'data:image/jpeg;base64,' + b64;
            return post(b64).then(function (url) {
              if (it.gone) return;
              it.url = url;
              it.el.classList.remove('is-busy');
              sync();
            });
          }).catch(function (why) {
            if (it.gone) return;
            drop(it);
            warn(why === 'read' ? 'This file could not be read. Please choose a JPG or PNG photo.' : 'Photo upload failed. Please try again.');
          });
        }
        pick.addEventListener('change', function () {
          var files = Array.prototype.slice.call(pick.files || []);
          pick.value = '';
          warn('');
          files.forEach(function (file) {
            if (items.length >= MAX) { warn('Maximum attachments: ' + MAX + ' photos'); return; }
            take(file);
          });
        });
        add.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick.click(); }
        });
        wrap.addEventListener('click', function (e) {
          var x = e.target.closest('[data-drop]');
          if (!x) return;
          e.preventDefault();
          warn('');
          drop(x.parentNode._it);
        });
      })();
      try {
        if (sessionStorage.getItem(SENT_KEY) && /[?&]contact_posted=true/.test(location.search)) {
          sessionStorage.removeItem(SENT_KEY);
          var thanks = $('[data-thanks]', root);
          if (thanks) {
            thanks.hidden = false;
            setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 300);
          }
        }
      } catch (e) {}
    }
  }

  /* --- detail view (one shared instance) --- */
  var modal = (function () {
    var el, items, idx, pic, root, voteFn, votes, lastFocus;

    function build() {
      el = document.createElement('div');
      el.className = 'nrn-rvm';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Review details');
      el.hidden = true;
      el.innerHTML =
        '<div class="nrn-rvm__wrap">' +
          '<button type="button" class="nrn-rvm__nav nrn-rvm__nav--p" data-nav="-1" aria-label="Previous review">' + icon('nrn-prev', '0 0 8 14') + '</button>' +
          '<button type="button" class="nrn-rvm__nav nrn-rvm__nav--n" data-nav="1" aria-label="Next review">' + icon('nrn-next', '0 0 8 14') + '</button>' +
          '<div class="nrn-rvm__item">' +
            '<div class="nrn-rvm__top"><button type="button" class="nrn-rvm__back" data-close aria-label="Back">' + icon('nrn-back', '0 0 16 14') + '</button><span class="nrn-rvm__pos" data-pos></span></div>' +
            '<div class="nrn-rvm__left" data-left><div class="nrn-rvm__stage" data-stage></div><div class="nrn-rvm__dots" data-dots></div><div class="nrn-rvm__thumbs" data-thumbs></div></div>' +
            '<div class="nrn-rvm__right"><button type="button" class="nrn-rvm__x" data-close aria-label="Close">' + icon('nrn-x', '0 0 10 10') + '</button><div class="nrn-rvm__info" data-info></div></div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);

      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t === el || t.closest('[data-close]')) return close();
        var nav = t.closest('[data-nav]');
        if (nav) return go(idx + (+nav.dataset.nav));
        var th = t.closest('[data-pic]');
        if (th) return show(+th.dataset.pic);
        var rb = t.closest('[data-react]');
        if (rb) { voteFn(items[idx].dataset.id, rb.dataset.react); paint(); return; }
        if (t.closest('[data-stage]')) { var n = media(items[idx]).length; if (n > 1) setTimeout(function () { show((pic + 1) % n); }, 0); }
      });
      var sx = null;
      el.addEventListener('touchstart', function (e) { if (e.target.closest('[data-stage]')) sx = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        sx = null;
        var n = media(items[idx]).length;
        if (Math.abs(dx) < 40 || n < 2) return;
        show((pic + (dx < 0 ? 1 : -1) + n) % n);
        e.preventDefault();
      });
      document.addEventListener('keydown', function (e) {
        if (!el || el.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') go(idx + 1);
        else if (e.key === 'ArrowLeft') go(idx - 1);
      });
    }

    function paint() {
      var id = items[idx].dataset.id;
      $$('[data-react]', el).forEach(function (b) {
        var on = votes[id] === b.dataset.react;
        var n = (+b.dataset.n || 0) + (on ? 1 : 0);
        b.classList.toggle('is-on', on);
        $('b', b).textContent = n > 0 ? n : '';
      });
    }

    function show(n) {
      var m = media(items[idx]);
      pic = n;
      var stage = $('[data-stage]', el);
      stage.innerHTML = '';
      var img = new Image();
      img.alt = 'Customer photo';
      img.src = m[n].u + '&width=1100';
      stage.appendChild(img);
      $$('[data-pic]', el).forEach(function (b) { b.classList.toggle('is-on', +b.dataset.pic === n); });
      $$('[data-dots] i', el).forEach(function (d, i) { d.classList.toggle('is-on', i === n); });
    }

    function go(n) {
      if (n < 0 || n >= items.length) return;
      idx = n;
      var card = items[idx];
      var m = media(card);
      var wrap = $('.nrn-rvm__wrap', el);
      wrap.classList.toggle('is-text', !m.length);
      $('[data-left]', el).hidden = !m.length;
      $('[data-thumbs]', el).innerHTML = m.length > 1 ? m.map(function (x, i) {
        return '<button type="button" data-pic="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + x.u + '&width=120" alt="" loading="lazy"></button>';
      }).join('') : '';
      $('[data-thumbs]', el).hidden = m.length < 2;
      $('[data-dots]', el).innerHTML = m.length > 1 ? m.map(function () { return '<i></i>'; }).join('') : '';
      if (m.length) show(0);

      var d = card.dataset, r = root.dataset;
      var title = d.pt || r.pt || '', url = d.pu || r.pu || '', pimg = d.pi || r.pi || '', price = d.pp || r.pp || '';
      var info = $('[data-info]', el);
      info.innerHTML =
        '<div class="nrn-rvm__acc"><div>' + $('.nrn-rvc__author', card).outerHTML + $('.nrn-rvc__meta', card).outerHTML + '</div>' + $('.nrn-rvc__rating', card).outerHTML + '</div>' +
        '<div class="nrn-rvm__text" data-mtext></div>' +
        $('.nrn-rvc__help', card).outerHTML +
        (title ? '<div class="nrn-rvm__prod">' + (pimg ? '<img src="' + pimg + '" alt="" width="40" height="40">' : '') + '<div><strong data-ptitle></strong><small data-pprice></small></div><a data-plink>View product</a></div>' : '');
      $('[data-mtext]', info).textContent = card._text || '';
      $('[data-mtext]', info).hidden = !card._text;
      if (title) {
        $('[data-ptitle]', info).textContent = title;
        $('[data-pprice]', info).textContent = price;
        $('[data-plink]', info).setAttribute('href', url);
      }
      paint();
      $('[data-pos]', el).textContent = (idx + 1) + '/' + items.length;
      $('[data-nav="-1"]', el).disabled = idx === 0;
      $('[data-nav="1"]', el).disabled = idx === items.length - 1;
      el.scrollTop = 0;
    }

    function close() {
      el.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    return {
      open: function (r, list, i, vf, vs) {
        if (!el) build();
        root = r; items = list; voteFn = vf; votes = vs;
        el.style.setProperty('--nrn-flags', getComputedStyle(root).getPropertyValue('--nrn-flags'));
        lastFocus = document.activeElement;
        el.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        go(Math.max(0, i));
        var x = $('.nrn-rvm__x', el);
        if (x && x.offsetParent) x.focus();
      }
    };
  })();

  function boot() {
    $$('[data-nrn-reviews]').forEach(init);
    $$('[data-nrn-review-badge]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('nrn-reviews');
        if (!target) return;
        e.preventDefault();
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
